<template>
    <div class="header">
    <div v-if="$vuetify.breakpoint.mdAndUp">
        <div class="headerTitle">
            <div v-if="isMiniMenu && badge">
                <v-badge :content="badge.smallText" :color="badge.color">
                <h2>{{ title }}</h2>
                </v-badge>
            </div>
            <h2 v-else>
                {{ title }}
            </h2>
        </div>
    </div>
        <v-spacer />
        <upload-button button-class="mt-2 mr-2"  :is-transmitting="isTransmitting" :connection-state="connectionState" :title="transferDialogTitle"/>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import UploadButton from "@/components/general/UploadButton.vue";
@Component({
    components: {UploadButton}
})
export default class DesktopHeader extends Vue {
    @Prop()
    private transferDialogTitle!:string;
    @Prop({default: false})
    private isTransmitting!: boolean;
    @Prop({default: 1})
    private connectionState!: number;
    @Prop({ default: '' })
    private title!: string;

    @Prop({default: false})
    private isMiniMenu!:boolean;
    @Prop({default: undefined})
    private badge!:{appAreaId:number,color:string,smallText:string,text:string};
}
</script>
